import { PutScrapFinanceAccountsApi } from "@/features/accounts/scrap-finance/services/put-accounts-api";
import { PutScrapFinanceAccountsRequestModel } from "@/features/accounts/scrap-finance/services/put-accounts-model";

/// 銀行口座更新処理
export class PutScrapFinanceAccountsService {
  private putScrapFinanceAccountsApi = new PutScrapFinanceAccountsApi();

  /**
   * 銀行口座更新API実行
   */
  public async putScrapFinanceAccounts(param: PutScrapFinanceAccountsRequestModel) {
    return await this.putScrapFinanceAccountsApi.putScrapFinanceAccounts(param);
  }
}
